<template>
    <form @submit.prevent="send">
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Recipients</p>
            </header>
            <section class="modal-card-body">
                <div class="field">
                    <o-checkbox
                            v-model="isExternal"
                            :false-value="null"
                    >
                        Is External
                    </o-checkbox>
                </div>

                <subscribers-resend
                        :reference-type="note.reference_type"
                        :reference-id="note.reference_id"
                        v-model="subscribers"
                />

                <br v-if="isExternal">
                <subscribed-contacts-resend
                        v-if="isExternal"
                        :reference-type="note.reference_type"
                        :reference-id="note.reference_id"
                        v-model="subscribedContacts"
                />
            </section>
            <footer class="modal-card-foot">
                <button
                        type="button"
                        class="button"
                       @click="$parent.$parent.$emit('update:active', false)">
                    Close
                </button>
                <button
                        v-submit="submitting"
                        v-if="sendButtonVisible"
                        class="button is-primary">
                    Send
                </button>
            </footer>
        </div>
    </form>
</template>

<script>
    import SubscribedContactsResend from '../NotesSubscribedContactsResend'
    import SubscribersResend from '../NotesSubscribersResend'
    import HandlesForm from '../../mixins/HandlesForm'
    import {mapActions} from 'vuex'

    export default {
        components: {
            SubscribedContactsResend,
            SubscribersResend
        },

        mixins: [HandlesForm],

        props: ['note'],

        data() {
            return {
                submittingSubscribedContacts: false,
                isExternal: !!this.note.is_external,
                isSubscribersModalActive: false,
                subscribedContacts: [],
                subscribers: [],
                sending: false
            }
        },

        computed: {
            sendButtonVisible() {
                return this.subscribers.length || (this.isExternal && this.subscribedContacts.length)
            }
        },

        methods: {
            ...mapActions(['resendNote']),

            send() {
                const params = {
                    subscribed_contacts: _.map(this.subscribedContacts, (subscribedContact) => subscribedContact.id),
                    subscribers: _.map(this.subscribers, (subscriber) => subscriber.id),
                    is_external: this.isExternal
                }

                this.submitting = true

                this.resendNote({
                    note: this.note, params
                }).then(() => {
                    this.successMessage('Note has been sent')
                    this.submitting = false
                    this.$parent.$parent.$emit('update:active', false)
                })
            }
        }
    }
</script>
